<template>
   <div class="fusion-time fusion-grid-page bg-light-purple pt-2">
      <NotFound v-if="!fusionGridDetailData" />
      <div v-if="fusionGridDetailData" class="content">
         <div class="main-content-block">
            <h1 class="mb-1">{{ fusionGridDetailData.content[0].header }}</h1>
            <p class="lead">
               {{ descriptionJoiner(fusionGridDetailData.content[0].shortDescription) }}
            </p>
            <div
               class="marked-header"
               v-html="markedRender(fusionGridDetailData.content[0].longDescription)"
            />
         </div>
      </div>
   </div>
</template>

<script>
import { mapState } from 'vuex';
import metaGenerator from '../../util/meta.js';
// import ChartView from '../../components/playground/ChartView.vue';
// import baseDropDown from '../../components/core/BaseDropdown';

export default {
   name: 'FusionGridDetailsDemo',
   components: {
      // ChartView,
      // baseDropDown,
   },

   data() {
      return {
         selectedChartType: { code: {}, preview: null, header: null },
         selectedTab: null,
         selectedIndex: 0,
         // ...(process.browser && { mixpanelanyProductPageTracker: this.$tracker.anyProductPage }),
         breakpoints: {
            small: 992,
         },
         tabSwiperOptions: {
            slidesPerView: 'auto',
            slidesPerGroup: 5,
            spaceBetween: 0,
            freeMode: true,
            navigation: {
               nextEl: '.swiper-button-next',
               prevEl: '.swiper-button-prev',
            },
         },
         isModalVisible: false,
         iframesrc: false,
         isClient: false,
      };
   },

   computed: {
      ...mapState(['fusionGridDetailData']),
   },

   watch: {
      selectedTab(val) {
         for (let i = 0, ii = this.chartTypes.length; i < ii; i++) {
            if (this.chartTypes[i].header === val) {
               if (i !== this.selectedIndex) {
                  this.selectedIndex = i;
               }
               break;
            }
         }
      },
      selectedIndex(val) {
         this.selectedTab = this.chartTypes[val].header;
         this.selectedChartType = this.chartTypes[val];
      },
   },

   asyncData({ store, route }) {
      return Promise.all([
         store.dispatch('FUSION_GRID_DETAILS_FETCH', {
            slug: route.params.slug,
         }),
         // store.dispatch('DASHBOARD_PAGE_DATA_FETCH'),
      ]);
   },

   mounted() {
      this.isClient = true;
      // eslint-disable-next-line
      //this.selectedChartType = this.chartTypes[0];
      // this.mixpanelanyProductPageTracker.visited();
   },

   metaInfo() {
      return metaGenerator(this.fusionGridDetailData);
   },
};
</script>

<style lang="scss" scoped>
@media (max-width: 576px) {
   .content {
      padding: 30px;
   }
}
</style>
